import { FUTURES } from "../../constants";

/**
 * Asks the positions table to close a trade with its usual confirmation flow.
 * @param {string|number} positionId
 */
export const requestPositionClose = (positionId) => ({
  type: FUTURES.REQUEST_POSITION_CLOSE,
  payload: positionId,
});

export const clearPositionCloseRequest = () => ({
  type: FUTURES.CLEAR_POSITION_CLOSE_REQUEST,
});
